<template>
  <div
    class="kye-report-dkp002"
    @click="handleClick('cardClick')"
  >
    <div
      class="dkp002_main-cell-title"
    >
      <img
        class="dkp002_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap,  ignoreEventName, args: ['main-icon1', data.mainIcon1]}"
      />
      <span
        class="dkp002_main-title"
        @click="handleClick('mainTitle')"
        v-events="{ eventsMap,  ignoreEventName, args: ['mainTitle', data.mainTitle]}"
      >{{ data.mainTitle }}</span>
      <KyeReportCardQuestion :icon="data.mainIcon2" :popover="data.popover" @click="handleClick('mainIcon2')" class="dkp002_main-icon2">
        <slot :name="'tooltip'"></slot>
      </KyeReportCardQuestion>
    </div>
    <div
      class="dkp002_main-cell-index"
      @click="handleClick('mainIndex')"
    >
      <div
        class="dkp002_main-index"
        v-events="{ eventsMap, args: ['main-index', data.mainIndex]}"
      >{{ data.mainIndex }}</div>
      <div
        class="dkp002_main-index-unit"
        v-events="{ eventsMap, args: ['main-index-unit', data.mainIndexUnit]}"
      >{{ data.mainIndexUnit }}</div>
    </div>
    <div
      class="dkp002_list"
    >
      <div
        class="dkp002_list-cell"
        v-for="(listItem, index) in data.list" :key="index"
      >
        <div
          class="dkp002_list-title"
          @click="handleClick('listTitle', index)"
          v-events="{ eventsMap, ignoreEventName,  args: ['listTitle', index, listItem.listTitle]}"
        >{{ listItem.listTitle }}</div>
        <div
          class="dkp002_list-cell-index"
        >
          <div
            class="dkp002_list-index"
            @click="handleClick('listIndex', index)"
            v-events="{ eventsMap, ignoreEventName,  args: ['listIndex', index, listItem]}"
          >{{ listItem.listIndex }}</div>
          <kyeReportCardArrow
            @click="handleClick('listIcon', index)"
            class="dkp002_list-icon"
            :type="listItem.listIcon"
            v-events="{ eventsMap, ignoreEventName, args: ['listIcon', index, listItem.listIcon]}"
          ></kyeReportCardArrow>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/dkp002.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportDkp002',
  components: {
    kyeReportCardArrow,
    KyeReportCardQuestion
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../style/extend.scss';
.kye-report-dkp002 {
  border: 1px solid #DCDCDC;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px;
  display: inline-block;
  cursor: pointer;
  .dkp002_main-cell-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    .dkp002_main-icon1 {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    .dkp002_main-title {
      color: #333333;
      font-size: 14px;
    }
    .dkp002_main-icon2 {
      margin-left: 4px;
    }
  }
  .dkp002_main-cell-index {
    display: flex;
    flex-direction: row;
    margin-top: 12px;
    color: var(--g-color-primary);
    font-weight: 600;
    line-height: 24px;
    .dkp002_main-index {
      font-size: 24px;
      line-height: 24px;
    }
    .dkp002_main-index-unit {
      font-size: 14px;
      margin-left: 2px;
      line-height: 14px;
      display: flex;
      flex-direction: column-reverse;
    }
  }
  .dkp002_list {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    .dkp002_list-cell {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      margin-top: 4px;
      flex: 1;
      gap: 4px;
      .dkp002_list-title {
        color: #999999;
        width: 74px;
        @extend %ellipse
      }
      .dkp002_list-index {
        color: #333333;
      }
      .dkp002_list-cell-index {
        display: flex;
        font-weight: 600;
        .list-icon {
          margin-left: 4px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dkp002/index.vue